import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { OiqLayoutAccountModel } from '@oiq-layout/layout.models';

@Component({
  selector: 'oiq-layout-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  imports: [CommonModule, MatIconModule, MatButtonModule, OverlayModule],
  host: {
    class: 'oiq-layout-account',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class OiqLayoutAccountComponent {
  @HostBinding('class.isImpersonated') get classIsImpersonated(): boolean {
    return this.isImpersonated;
  }
  @Output() logout = new EventEmitter<void>();
  @Input() isImpersonated: boolean = false;
  @Input() account: OiqLayoutAccountModel | null = null;

  isUserMenuOpen = false;

  toggleUserMenu() {
    if (this.isImpersonated) {
      this.isUserMenuOpen = false;
      return;
    }
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  get camelToLabel(): (value: string) => string {
    return (value: string): string => {
      if (!value) {
        return value;
      }

      // Convert to lowercase and replace underscores with spaces
      let result = value.toLowerCase().replace(/_/g, ' ');

      // Adds a space before all capital letters that are preceded by lowercase letters
      result = result.replace(/([a-z])([A-Z])/g, '$1 $2');

      // Capitalizes the first letter of each word
      result = result.replace(/\b\w/g, char => char.toUpperCase());

      // The lowercasing above flattens acronyms and connecting words, which reads wrong for role
      // names coming in fully capitalised: MANAGER OF ISO MANAGERS -> Manager of ISO Managers
      result = result.replace(/\bIso\b/g, 'ISO');
      result = result.replace(/\bOf\b/g, 'of');

      // Add a space around numbers
      result = result.replace(/([a-zA-Z])(\d+)/g, '$1 $2');
      result = result.replace(/(\d+)([a-zA-Z])/g, '$1 $2');

      return result;
    };
  }
}
